import { render } from "./TccDocsHome.vue?vue&type=template&id=6a889cec&scoped=true"
import script from "./TccDocsHome.vue?vue&type=script&lang=js"
export * from "./TccDocsHome.vue?vue&type=script&lang=js"

import "./TccDocsHome.vue?vue&type=style&index=0&id=6a889cec&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a889cec"]])

export default __exports__